import ApiService from "./ApiService";
import {AUTH_TOKEN} from "../constants/AuthConstant";
import {isMobileApp} from "../configs/AppConfig";

const defaultService = {}

function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}


var ACKREQUESTS = []
var LISTENERS = []

function onMessage(payload) {
    //console.log("ONMESSAGE",payload)

    const type = payload.type
    const session = payload.session

    if (session) {
        var ackIndex = ACKREQUESTS.findIndex(i => i.session == session)
        if (ackIndex !== -1) {
            ACKREQUESTS[ackIndex].callback(payload)
            ACKREQUESTS.splice(ackIndex, 1)
        }
    } else {
        for (var listener of LISTENERS) {
            if (listener.type == type) {
                listener.callback(payload)
            }
        }
    }

}


function sendMessage(payload) {
    if (!window.ReactNativeWebView) {
        console.log("Unable to communicate with native app")
        return false
    }

    console.log(window.ReactNativeWebView.postMessage)

    //console.log("POST MESSAGE",payload)

    var res = window.ReactNativeWebView.postMessage(JSON.stringify(payload))

    console.log(res)

    return true
}

function sendWithACK(type, params) {
    const session = uuidv4()

    const payload = {type: type, session: session, data: params}

    return new Promise((resolve, reject) => {
        let timeout = setTimeout(() => reject({success: false, error: "SESSION TIMEOUT"}), 60 * 1000)

        ACKREQUESTS.push({
            session: session, callback: (result) => {
                clearTimeout(timeout)
                const data = result.data
                //console.log("ACK DATA",data)
                resolve(data)
            }
        })

        if (!sendMessage(payload)) {
            reject({success: false, error: "SEND ERROR"})
        }
    })
}


defaultService.getNotifToken = async () => {
    const dataToken = await sendWithACK("FCM.token", null)
    if (dataToken.success) {
        const token = dataToken.data
        console.log("NOTIF TOKEN", token)
        if (token) {
            return token
        }
    }

    return null
}

function initObserver() {
    window.sendMessage = sendMessage

    function appModalLink(aNode) {
        aNode.setAttribute('target', '_self')
        let href = aNode.getAttribute('href')
        aNode.removeAttribute('href', '')

        if (!href.startsWith("http")) {
            href = window.location.origin + href
        }
        aNode.setAttribute('onClick', 'window.sendMessage({type:"open_modal",data:{url:"' + href + '"}})')
    }

    new MutationObserver(function (mutationsList, observer) {
        // Parcourir les mutations détectées
        for (let mutation of mutationsList) {
            // Vérifier si un noeud a été ajouté
            if (mutation.type === 'childList') {
                // Vérifier chaque noeud ajouté
                mutation.addedNodes.forEach(function (node) {
                    // Vérifier si le noeud ajouté est une balise <a>
                    if (node.tagName && node.tagName.toLowerCase() === 'a' && node.getAttribute("target") === "_blank") {
                        // Modifier l'attribut target de la balise <a>
                        //console.log(node)
                        appModalLink(node)
                    } else if (node.querySelectorAll) {
                        // Si le nœud ajouté contient des descendants, vérifiez-les également
                        const anchorNodes = node.querySelectorAll('a');
                        anchorNodes.forEach(function (anchorNode) {
                            if (anchorNode.getAttribute("target") === "_blank") {
                                //console.log(anchorNode)
                                appModalLink(anchorNode)
                            }
                        });
                    }
                });
            }
        }
    }).observe(document.body, {childList: true, subtree: true})

}


defaultService.sendMessage = sendMessage

defaultService.init = () => {
    if (window.ISAPP) {
        initObserver()

        window.addEventListener("message", function (event) {
            try {
                onMessage(JSON.parse(event.data));
            } catch (e) {
            }
        });

        document.addEventListener("message", function (event) {
            try {
                onMessage(JSON.parse(event.data));
            } catch (e) {
            }
        });

        sendMessage({type: "init", data: {}})

        return true
    }

    return false
}


defaultService.addEventListener = function (type, callback) {

    const id = uuidv4()

    const remove = () => {
        const index = LISTENERS.findIndex(i => i.id == id)
        if (index === -1) {
            throw new Error("Unable to remove listener " + id + " " + type)
        }
        LISTENERS.splice(index, 1)
    }

    LISTENERS.push({
        id: id,
        type: type,
        callback: callback
    })

    return remove
}

//SYSTEM

async function get(type,params={})
{
    try {
        return await sendWithACK(type, params)
    } catch (error) {
        console.log(error)
        return error
    }
}

defaultService.get =get


defaultService.shareBase64 = async function (url, params = {})
{
    if(!window.ISAPP){
        window.open(url, "_blank")
        return false
    }

    console.log("shareBase64",url,params)

    let base64=null
    const token = localStorage.getItem(AUTH_TOKEN) || null;
    const req=await fetch(url,{headers:{"authorization":token}});
    if(req.ok){
        const blob = await req.blob();
        base64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    params.url=base64

    try {
        return await get("share", params)
    } catch (error) {
        console.error(error)
        return error
    }

}

defaultService.share = async function (params = {})
{
    console.log("share",params)

    if(!window.ISAPP){
        return false
    }

    try {
        return await get("share", params)
    } catch (error) {
        console.log(error)
        return error
    }
}


defaultService.setNavigationGesture = async function (bool=false)
{
    if(!isMobileApp){
        return false
    }

    console.log("setNavigationGesture",bool)

    let route="gesture.disable"
    if(bool){
        route="gesture.enable"
    }

    try {
        return await get(route, {})
    } catch (error) {
        console.log("setNavigationGesture ERROR",error)
        return error
    }
}


export default defaultService
